<template>
  <div class="clinic-management-role">
    <header class="role-page-header">
      <div class="role-page-title-row">
        <h1 class="role-page-title">角色管理</h1>
      </div>
    </header>
    <div class="role-content">
      <aside class="role-left">
        <RoleList ref="roleList" @updateRoleInfo="updateRoleInfo" @addRoleInfo="addRoleInfo"></RoleList>
      </aside>
      <main class="role-right">
        <RoleInfoContent
            :currentStatus.sync="currentStatus"
            :roleTreeList="roleTreeList"
            :roleInfoData="roleInfoData"
            @statusValueChange="statusValueChange"
            @cancelAddRole="cancelAddRole"
            @addRoleHandle="addRoleHandle"
        ></RoleInfoContent>
      </main>
    </div>
  </div>
</template>

<script>
import RoleList from "./RoleList.vue";
import RoleInfoContent from "./RoleInfoContent.vue";

export default {
  name: "RoleManager",
  components: {
    RoleList,
    RoleInfoContent,
  },
  data() {
    return {
      roleInfoData: {roleDesc: "", roleName: "", roleScope: 1, status: 1},
      currentRoleId: 0,
      roleTreeList: [],
      /**
       * 目前定义三种状态：
       *  system ：系统创建角色
       *  user ： 用户定义的角色
       *  add : 新增角色
       */
      currentStatus: "user"
    }
  },
  methods: {
    /**
     * 点击左侧子组件，刷新父组件里保存的数据
     */
    updateRoleInfo(data) {
      this.currentRoleId = data.id;
      this.roleInfoData = data;
      this.currentStatus = data.roleScope === 0 ? "system" : "user";
      this.$http.get(process.env.VUE_APP_API_HOST + "/api/get_role_btns?id=" + this.currentRoleId).then(res => {
        if (res.data) {
          this.roleTreeList = res.data.data.data;
        }
      });
    },
    /**
     * 保存按钮事件
     * 根据当前保存的角色id，判断正在进行的操作是新增还是修改；
     */
    addRoleHandle(data) {
      console.log(data)
      if (this.currentRoleId === 0) {
        this.$http.post(process.env.VUE_APP_API_HOST + "/api/add_role", data).then(res => {
          if (res.data) {
            this.$refs.roleList.getAllRoles(res.data.id);
          }
        });
      } else {
        data['id']=this.currentRoleId
        this.$http.post(process.env.VUE_APP_API_HOST + "/api/update_role", data).then(() => {
          this.$refs.roleList.getAllRoles(this.currentRoleId);
        });
      }
    },
    /**
     * 点击新增按钮
     * 新增时，将当前保存的角色id修改0
     */
    addRoleInfo() {
      this.currentRoleId = 0;
      this.roleInfoData = {roleDesc: "", roleName: "", roleScope: 1, status: 1};
      // this.roleTreeList = [2];
      this.currentStatus = "add";
    },
    /**
     * 取消按钮事件
     */
    cancelAddRole() {
      this.$refs.roleList.getAllRoles(this.currentRoleId);
    },
    /**
     * 右侧开关事件
     * 因为change事件是值变化后调用的，在这里暂时把值改回来，再进行操作，模拟中断开关事件场景
     */
    statusValueChange(val) {
      this.roleInfoData.status = val === 1 ? 2 : 1;
      let str = this.roleInfoData.status === 2 ? "启用" : "禁用";
      this.$confirm(`是否${str}该角色`, {
        type: "warning"
      }).then(() => {
        this.$http.post(process.env.VUE_APP_API_HOST + "/api/update_role_status_del",
            { id: this.currentRoleId, status: val }).then(() => {
          this.$refs.roleList.getAllRoles(this.currentRoleId);
        });
      });
    },
  }
}
</script>

<style scoped lang="less">
@bg-page: #12141a;
@surface: #3c3f4a;
@border: rgba(255, 255, 255, 0.09);
@accent: #2ecd81;
@text: rgba(255, 255, 255, 0.93);

.clinic-management-role {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: calc(100vh - 115px) !important;
  padding: 28px clamp(28px, 4vw, 56px) 32px;
  font-size: 15px;
  color: @text;
  background: @bg-page;
  max-width: 1680px;
  margin: 0 auto;
  width: 100%;
}

.role-page-header {
  flex-shrink: 0;
  padding-bottom: 22px;
  border-bottom: 1px solid @border;
}

.role-page-title-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}

.role-page-title {
  position: relative;
  margin: 0;
  padding-left: 16px;
  font-size: clamp(22px, 2.2vw, 26px);
  font-weight: 600;
  letter-spacing: 0.06em;
  line-height: 1.35;
  color: @text;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 1.15em;
    border-radius: 3px;
    background: linear-gradient(180deg, lighten(@accent, 6%) 0%, @accent 100%);
    box-shadow: 0 0 20px fade(@accent, 35%);
  }
}

.role-content {
  display: flex;
  flex: 1;
  min-height: 0;
  margin-top: 24px;
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid @border;
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.06) inset,
    0 24px 56px rgba(0, 0, 0, 0.42),
    0 8px 24px rgba(0, 0, 0, 0.22);
  background: @surface;
}

.role-left {
  flex-shrink: 0;
  width: min(384px, 34%);
  min-width: 300px;
  box-sizing: border-box;
  padding: 26px 22px 28px 26px;
  border-right: 1px solid @border;
  background: darken(@surface, 3%);
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.role-right {
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  padding: 28px clamp(24px, 3vw, 44px) 32px;
  background: @surface;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
</style>

